import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["burger", "menu"]

  toggle(event) {
    event.preventDefault()
    this.burgerTarget.classList.toggle("is-active")
    this.menuTarget.classList.toggle("is-active")
  }

  toggleDropdown(event) {
    event.preventDefault()
    const item = event.currentTarget.closest(".has-dropdown")
    if (!item) return

    this.element.querySelectorAll(".has-dropdown.is-active").forEach((open) => {
      if (open !== item) open.classList.remove("is-active")
    })
    item.classList.toggle("is-active")
  }
}
